module.exports = __webpack_public_path__ + "img/main_logo.d0b0acda.svg";